import { render } from "./ThirdSectionImage.vue?vue&type=template&id=d2f3fb6a&scoped=true"
import script from "./ThirdSectionImage.vue?vue&type=script&lang=ts"
export * from "./ThirdSectionImage.vue?vue&type=script&lang=ts"

import "./ThirdSectionImage.vue?vue&type=style&index=0&id=d2f3fb6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2f3fb6a"

export default script